import { Box } from "@origin-digital/ods-core";
import styled from "styled-components";

export const InteractiveBox = styled(Box)(({ theme }) => ({
  backgroundColor: "white",
  "&:hover": {
    // backgroundColor: "#f8f8f8",
    backgroundColor: theme.colors.grey50,
  },
  "&:focus": {
    backgroundColor: theme.colors.grey100,
  },
}));
